<template>
  <div class="col col-lg-3">
    <label for="agenciaField">
      Agência <span class="required-markup">*</span>
      <span class="recent-updated-label" v-if="recentUpdatedField">
        <tooltip-informacao-alterada />
      </span>
      <div class="input-group">
        <input
          :disabled="disabled"
          class="form-control"
          maxlength="15"
          :class="{
            'is-invalid': $v.model.content.$error,
            'recent-updated': recentUpdatedField,
          }"
          id="agenciaField"
          v-model.trim="$v.model.content.$model"
          placeholder="0000"
          v-mask="'9999'"
        />
      </div>
    </label>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import { required , minLength } from "vuelidate/lib/validators";
import FieldTemplate from "@/components/forms/fields/empresa/FieldTemplate.vue";
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
export default {
  extends: FieldTemplate,
  props: {
    disabled: Boolean,
    modelProp: Object,
    recentUpdatedField: Boolean,
  },
  data() {
    return {
      model: {
        name: "agencia",
        content: "",
      },
    };
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    isInvalid() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.mxToggleErrorMessageAlert("Campo Agência inválido");
        return true;
      }
      return false;
    },
  },
  validations: {
    model: {
      content: {
        required,
        minLength: minLength(4),
      },
    },
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}
</style>
